import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IEditObjectDialogDataItem } from '@fi-shared/fi-edit-object-dialog/fi-edit-object';

@Component({
    selector: 'fi-object-edit-color-picker',
    template: `
        <div class="color-palette-container">
            <fi-color-palette-picker
                [(color)]="this.changedItem.Color"
                (colorChange)="valueChanged()"
            ></fi-color-palette-picker>
        </div>
    `,
    styleUrls: ['./fi-object-edit-color-picker.component.scss'],
    standalone: false,
})
export class FiObjectEditColorPickerComponent implements OnInit {
    @Input() changedItem: IEditObjectDialogDataItem;
    @Output() onValueChanged = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}

    valueChanged() {
        this.onValueChanged.emit();
    }
}
